export enum EnumContractsStatus {
    Active = 'Ativo',
    Inactive = 'Não Ativo',
    Canceled = 'Cancelado',
}

export const contractsStatus = Object.entries(EnumContractsStatus).map(([key, value]) => ({ value: key, label: value }));
